import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "transaction-other-next",
  "use": "transaction-other-next-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"transaction-other-next\">\r\n<circle cx=\"2.5\" cy=\"7.5\" r=\"2.5\" fill=\"#989A9B\" />\r\n<circle cx=\"13.5\" cy=\"7.5\" r=\"2\" stroke=\"#C4C4C4\" />\r\n<path d=\"M9.969 5.185L8.7 5.392L9.609 6.31L8.619 7.03L8.025 5.887L7.431 7.039L6.441 6.319L7.341 5.401L6.072 5.185L6.441 4.051L7.593 4.609L7.413 3.322H8.637L8.448 4.618L9.591 4.042L9.969 5.185Z\" fill=\"#C4C4C4\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol